import {  useState } from "react";
import { Modal } from "react-bootstrap";
import {  useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import AIPermissions from "./AIPermissions";
import { TbLock, TbWorldWww } from "react-icons/tb";
import Domains from "./Domains";

const AISettingsModal = ({ show, handleClose, context }) => {
    const { t } = useLanguage();
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [error, setError] = useState({ message: "", display: false });
    const [openLink, setOpenLink] = useState("ai_permissions")
    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setOpenLink("ai_permissions")
    };



    return (
        <Modal show={show} onHide={CloseModal} className="modal_ai_settings">

            <div className="main_settings_cont">
                <div className="main_settings_container">
                    <div className="sidebar_main_settings">
                        <p className="sidebar_main_settings_title">Settings</p>
                        <p className={`sidebar_main_settings_link ${openLink == "ai_permissions" ? "sidebar_main_settings_link_selected" : ""}`} onClick={() => setOpenLink("ai_permissions")}><TbLock /> AI Permissions</p>
                        <p className={`sidebar_main_settings_link ${openLink == "domains" ? "sidebar_main_settings_link_selected" : ""}`} onClick={() => setOpenLink("domains")}><TbWorldWww /> Domains</p>
                        {/* <p className={`sidebar_main_settings_link ${openLink == "github" ? "sidebar_main_settings_link_selected" : ""}`} onClick={() => setOpenLink("github")}><TbBrandGithub /> GitHub</p> */}
                        {/* <p className={`sidebar_main_settings_link ${openLink == "erioon_store" ? "sidebar_main_settings_link_selected" : ""}`} onClick={() => setOpenLink("erioon_store")}><TbGalaxy /> Erioon Store</p> */}
                    </div>
                    {openLink == "ai_permissions" ? (
                        <div className="ai_settings_cont_modal">
                            <AIPermissions show={show} CloseModal={CloseModal}/>
                        </div>
                    ) : openLink == "domains" ? (
                        <div className="ai_settings_cont_modal">
                            <Domains  show={show} CloseModal={CloseModal} context={context}/>
                        </div>
                    ) : openLink == "erioon_store" ? (
                        <div className="ai_settings_cont_modal">
                        </div>
                    ) : (
                        <div className="ai_settings_cont_modal"></div>
                    )}
                </div>


            </div>
        </Modal>
    );
};

export default AISettingsModal;
